module.exports = __webpack_public_path__ + "static/media/waves-exchange.8c9ebb26.svg";